(function() {
    var module;

    try {
        // Get current templates module
        module = angular.module('templates');
    } catch (error) {
        // Or create a new one
        module = angular.module('templates', []);
    }

    module.run(["$templateCache", function($templateCache) {
        $templateCache.put('module/slides/results.html', '<div class=\"slide slide--center\"  ng-controller=\"SlideResultsCtrl\"  ng-class=\"{\'slide--{{ slide.type }}\': slide.type, \'slide--bg-gradient\': slide.gradient}\">\n\n	<div class=\"slide_inner\">\n		<div class=\"slide_content\">\n			<div class=\"v-align\">\n				<h1 ng-if=\"resultFeedbackTitle\">{{ resultFeedbackTitle }}</h1>\n				\n				<h3 ng-if=\"resultFeedbackExplanation\">\n					{{resultFeedbackExplanation}}\n				</h3>\n\n			</div>\n		</div>\n		\n	</div>\n</div>');
    }]);
})();